import { derivedSurfaceTreatments } from '@figma/fpl-tokens/surface-treatments';
import { mergeProps } from '../utils/merge-props.js';
import '@figma/fpl-tokens/surface.css';

/** Apply a Surface treatment to an element that owns both interaction and paint. */
function getSurfaceProps(options, ...additionalProps) {
    return getSplitSurfaceProps(options, ...additionalProps).paintProps;
}
/**
 * Split a Surface treatment when a direct parent owns interaction and its child paints the
 * treatment. Additional props are composed onto the paint element.
 */
function getSplitSurfaceProps({ color, disabled, hover, focusVisible, focusWithin, pressed, disableECOutline, }, ...additionalProps) {
    const colorTreatment = color || undefined;
    if (disabled) {
        return {
            interactionProps: { 'data-fpl-surface-trigger': '' },
            paintProps: mergeProps(...additionalProps, {
                'data-fpl-surface': colorTreatment ?? '',
                'data-fpl-surface-disable-ec-outline': disableECOutline ? '' : undefined,
                'data-fpl-surface-hover': undefined,
                'data-fpl-surface-focus-visible': undefined,
                'data-fpl-surface-focus-within': undefined,
                'data-fpl-surface-pressed': undefined,
            }),
        };
    }
    const derivedTreatments = derivedSurfaceTreatments[colorTreatment ?? 'default'];
    const hoverTreatment = hover === true ? derivedTreatments.hover : hover || undefined;
    const focusVisibleTreatment = focusVisible === true ? derivedTreatments.focusVisible : focusVisible || undefined;
    const focusWithinTreatment = focusWithin === true ? derivedTreatments.focusWithin : focusWithin || undefined;
    const pressedTreatment = pressed === true ? derivedTreatments.pressed : pressed || undefined;
    const paintProps = {
        'data-fpl-surface': colorTreatment ?? '',
        'data-fpl-surface-disable-ec-outline': disableECOutline ? '' : undefined,
        'data-fpl-surface-hover': hoverTreatment,
        'data-fpl-surface-focus-visible': focusVisibleTreatment,
        'data-fpl-surface-focus-within': focusWithinTreatment,
        'data-fpl-surface-pressed': pressedTreatment,
    };
    return {
        interactionProps: { 'data-fpl-surface-trigger': '' },
        paintProps: mergeProps(...additionalProps, paintProps),
    };
}

export { getSplitSurfaceProps, getSurfaceProps };
//# sourceMappingURL=surface.utils.js.map
